<template>
  <div>
    <active></active>
    <login ref="login" @goto="reGoto"></login>
    
  </div>
</template>
<script>
import axios from "axios";
import active from "./active.vue"
import login from "../../../node_modules/common/src/components/sys/login.vue";
export default {
  components: { login,active },
  data() {
    return {
      
    };
  },
  methods: {
    reGoto() {
      this.$router.push({
        path: "/control",
        query: { now: 0 },
      });
      location.reload();
    },
    
  },
  mounted() {
    setTimeout(() => {
      this.$refs.login.reachData(axios);
      
    }, 200);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/login/index.vue